<div class="encabezado">
  <div>
    <div>
      <div>
        <h5 class="titulo1">{{ "titles-menu-pages." + title | translate }}</h5>
      </div>
    </div>
  </div>
  <div class="">
    <div class="">
      <div class="row">
        <div class="col-8">
          <app-shared-filter
            (filterChanged)="filterChanged($event)"
            [type]="'orders'"
            [stage_type]="stage_type"
            [initialValues]="filterInitialValues"
          ></app-shared-filter>
        </div>
        <!--  <div class="col-8">
          <app-filter [ladata]="ladata" (filterChanged)="filterChanged($event)" [stage_type]="stage_type"
            [userRole]="userRole"></app-filter>
        </div> -->
        <div
          class="col-4"
          *ngIf="
            accountType == 'broker' &&
            this.typeOrders != 'cancelled' &&
            this.typeOrders != 'frozen'
          "
        >
          <div class="btn-izq">
            <button class="btn btn-hover add-order-btn" type="button" (click)="toggleForm()">
              <span class="add-btn-text">{{ "buttons.add+" | translate }}</span> <i class="icon-plus"></i>
            </button>
          </div>
        </div>

        <div class="col-4" *ngIf="accountType == 'supplier' && showPdfButton()">
          <div class="btn-izq">
            <button
              class="btn btn-hover"
              type="button"
              (click)="toggleFormPdf()"
            >
              <span class="add-btn-text">{{ "buttons.add_pdf+" | translate }}</span> <i class="icon-plus"></i>
            </button>
          </div>
        </div>

        <div
          class="col-4 d-flex align-items-end justify-content-end"
          *ngIf="this.typeOrders == 'frozen'"
        >
          <div class="btn-izq">
            <a class="pre-frozen" href="/orders/pre-frozen">
              {{ "buttons.pre-frozen" | translate }}</a
            >
          </div>
        </div>
      </div>
    </div>

    <!-- ✅ FASE C1: Alertas de filtro usando OrdersAlertService -->
    <div class="row" *ngIf="(alertState$ | async)?.showAlertFilterEst">
      <div class="col-12">
        <div class="alert alert-warning alert-dismissible fade show" role="alert" 
             [innerHTML]="getEstimatedFilterMessage()">
        </div>
      </div>
    </div>

    <!-- Alerta de filtro general -->
    <div class="row" *ngIf="(alertState$ | async)?.showAlertFilter">
      <div class="col-12">
        <div class="alert alert-warning alert-dismissible fade show" role="alert"
             [innerHTML]="getGeneralFilterMessage()">
        </div>
      </div>
    </div>


    <div class="tabla">
      <!-- ✅ FASE B3: OrdersActionsBarComponent con AuthStateService integrado -->
      <app-orders-actions-bar
        [selectedCount]="selectedReferencesSize"
        [typeOrders]="typeOrders"
        (changeStatusSelected)="openBulkStageUpdateModal()"
        (importData)="openImportOptions()"
        (exportAll)="openExportOptions()">
        <!-- Paginador pasado como contenido proyectado -->
        <mat-paginator
          paginator
          [length]="paginator ? (paginator.length ? paginator.length : 25) : 25"
          [pageSize]="paginator.pageSize"
          [pageSizeOptions]="[5, 10, 25, 100]"
          [hidePageSize]="true"
          (page)="onPageChange($event)">
        </mat-paginator>
      </app-orders-actions-bar>

      <!-- ✅ FASE B2: OrdersTableComponent integrado (usando estado centralizado) -->
      <app-orders-table
        [orders]="(orders$ | async) || []"
        [displayedColumns]="displayedColumns"
        [typeOrders]="typeOrders"
        [accountType]="accountType"
        [userRole]="userRole"
        [sortColumn]="sortColumn"
        [sortDirection]="sortDirection"
        [expandedRow]="expandedRow"
        [loading]="(loading$ | async) || false"
        (rowClick)="onRowClick($event)"
        (sortChange)="onSortChange2($event)"
        (expandedRowChange)="expandedRow = $event"
        (deleteOrderClick)="deleteOrder($event)"
        (editOrderClick)="getOrder($event)"
        (openNotesClick)="openOrderNotes($event)"
        (documentClick)="handleClickDocument($event)"
        (selectionChange)="handleSelectionChange()"
      ></app-orders-table>

      <mat-paginator
        [length]="paginator.length ? paginator.length : 25"
        [pageSize]="paginator.pageSize"
        [pageSizeOptions]="paginator.pageSizeOptions"
        (page)="onPageChange($event)"
      >
      </mat-paginator>
    </div>
  </div>

  <div
    class="formulario-derecha-container"
    [ngClass]="{ 'mostrar-formulario': showFormPdf }"
  >
    <app-form-add-order-pdf
      *ngIf="showFormPdf"
      [orderData]="orderData"
      [tab]="tab"
      (backButtonClick)="cerrarFormularioPdf()"
      (addOrder)="refrescar()"
      (addOrderPdf)="getOrderPdf($event)"
      [document_buttons_chico]="document_buttons_chico"
      [ladata]="ladata"
    ></app-form-add-order-pdf>
  </div>

  <div
    class="formulario-derecha-container"
    [ngClass]="{ 'mostrar-formulario': showImportExcel }"
  >
    <app-form-update-excel
      *ngIf="showImportExcel"
      [orderData]="orderData"
      [tab]="tab"
      (backButtonClick)="cerrarFormularioExcel()"
      [document_buttons_chico]="document_buttons_chico"
      [ladata]="ladata"
      (import)="finishImport($event)"
    ></app-form-update-excel>
  </div>

  <div
    class="formulario-derecha-container"
    [ngClass]="{ 'mostrar-formulario': showForm }"
  >
    <app-form-add-order
      *ngIf="showForm"
      [orderData]="orderData"
      [tab]="defaultTab"
      (backButtonClick)="cerrarFormulario()"
      (addOrder)="refrescar()"
      (emitOpenClientForm)="openClientForm($event)"
      (emitOpenAssigneeForm)="openAssigneeForm($event)"
      (emitCloseClientForm)="closeClientForm()"
      (emitOpenAddressesForm)="openAddressesForm()"
      (emitCloseAssigneeForm)="closeAssigneeForm()"
      (emitCloseAddressesForm)="closeAddressesForm()"
      (emitOpenMailPanel)="openMailPanel($event)"
      (emitCloseMailPanel)="closeMailPanel()"
      (emitOpenCallPanel)="openCallPanel($event)"
      (emitCloseCallPanel)="closeCallPanel()"
      [document_buttons_chico]="document_buttons_chico"
      [ladata]="ladata"
      (emitOpenAssigneeCreateForm)="openAssigneeCreateForm()"
      (loadOrder)="getOrder($event)"
    ></app-form-add-order>
  </div>

  <div
    class="formulario-sub-derecha-container"
    [ngClass]="{ 'mostrar-formulario': showMailPanel }"
  >
    <app-send-mail-panel
      *ngIf="showMailPanel"
      [visible]="showMailPanel"
      [clientReference]="mailPanelData.reference"
      [clientEmail]="mailPanelData.email"
      [clientName]="mailPanelData.name"
      (closed)="closeMailPanel()"
      (mailSent)="closeMailPanel()">
    </app-send-mail-panel>
  </div>

  <div
    class="formulario-sub-derecha-container"
    [ngClass]="{ 'mostrar-formulario': showCallPanel }"
  >
    <app-call-panel
      *ngIf="showCallPanel"
      [visible]="showCallPanel"
      [phoneNumber]="callPanelData.phone"
      [contactName]="callPanelData.name"
      [clientReference]="callPanelData.clientReference"
      (closed)="closeCallPanel()">
    </app-call-panel>
  </div>

  <div
    class="formulario-sub-derecha-container"
    [ngClass]="{ 'mostrar-formulario': showAddressesForm }"
  >
    <app-addresses-form
      *ngIf="showAddressesForm"
      (backButtonClick)="closeAddressesForm()"
      (selectAddresses)="selectAddresses($event)"
    >
    </app-addresses-form>
  </div>

  <div
    class="formulario-sub-derecha-container"
    [ngClass]="{ 'mostrar-formulario': showAddClientForm }"
  >
    <app-form-add-client
      *ngIf="showAddClientForm"
      [optAdd]="optAdd"
      [noAgregarFlag]="true"
      [autoAssign]="true"
      [orderReference]="order_reference"
      (clientAutoAssign)="clientAutoAssign($event)"
      (backButtonClick)="cerrarClienteFormulario()"
      (addClient)="refreshClients()"
      (emitOpenAssigneeCreateForm)="openAssigneeCreateForm()"
    >
    </app-form-add-client>
  </div>

  <div
    class="formulario-sub-derecha-container assignee"
    [ngClass]="{ 'mostrar-formulario': showAssigneeCreateForm }"
  >
    <app-form-add-assignee
      *ngIf="showAssigneeCreateForm"
      (clientDuplicateFound)="openClientForm($event)"
      (backButtonClick2)="cerrarFormularioCreateAssignee()"
      (closeAssigneeCreateForm)="cerrarFormularioCreateAssignee()"
    ></app-form-add-assignee>
  </div>

  <div
    class="formulario-sub-derecha-container"
    [ngClass]="{ 'mostrar-formulario': showAssigneeForm }"
  >
    <app-form-show-assignee
      *ngIf="showAssigneeForm"
      (backButtonClick)="cerrarAssigneeFormulario()"
      [assignee]="assignee"
      (addClient)="refreshClients()"
      [ladata]="ladata"
    >
    </app-form-show-assignee>
  </div>



  <div
    class="overlay"
    *ngIf="showForm || showFormPdf || showAssigneeCreateForm"
    (click)="cerrarFormulario()"
  ></div>
</div>
